module.exports = __webpack_public_path__ + "static/img/3.b4940f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/eng/3.png
// module id = yQw9
// module chunks = 0